/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { mj_return_false } from './util.js';
import { setInSession, getFromSession } from './session-util.js';
import { $ } from '../other/jquery-hooked.js';

import { confirm_box } from './page-modal.js';


// open/close container states
var oc_states = {};

export function create_common_hooks() {
	var tmp_ocs = getFromSession('open_close_state',null);
	if( tmp_ocs!=null ) oc_states = JSON.parse(tmp_ocs);
	$(document)
		.on('click','.mjh_oc', function(e) {
			var s = $(this),
				container = $( s.attr('mj_oc_container') ),
				o = container.css('display')=='none',
				ss = [];
			container
				.css( 'display', o ? (s.attr('mj_oc_display')||'block') : 'none' )
				.triggerHandler( o ? 'mjscontaineropen' : 'mjscontainerclose' );
			oc_states[ s.attr('mj_oc_id') ] = o;
			s.toggleClass( 'opened', o );
			// quick & dirty & fast JSON.stringify() for oc_states ...
			for( var k in oc_states ) {
				if( !oc_states.hasOwnProperty(k) ) continue;
				ss.push( '"'+k+'":'+(oc_states[k]?'1':'0') );
			}
			setInSession( 'open_close_state', '{'+ss.join(',')+'}' );
		} )
		.on('keydown','.delete-link,.emph-link,.cancel-link,.link,.xlink', function(e) {
			if( !e.isDefaultPrevented() && e.which && ( e.which===32 || e.which===13 ) ) {
				// SPACE or ENTER pressed
				var click_target = $(this);
				// trigger with delay -> so, that the new dialogs handlers will not trigger simultaneously
				setTimeout( function() {
					click_target.trigger('click');
				}, 250 );
				e.preventDefault();
				e.stopPropagation();
			}
		} );
	update_common_hooks( document );
}

// call after adding new html with delete-links, hover images etc. to the page
export function update_common_hooks( ctx ) {
	$('[mj_confirm]',ctx).not('.mjh_c').addClass('mjh_c').each( function _mjh_c() {
		var self = $(this);
		var onclick = self.attr('onclick');
		self
			.attr('onclick','') // IE7 quirk
			.removeAttr('onclick')
			.off('click')
			.click( function() {
				confirm_box(self.attr('mj_confirm_title'),self.attr('mj_confirm'), function() {
					if( typeof onclick === 'function' ) {
						onclick();
					} else if( onclick ) {
						var indirect_eval = eval;
						indirect_eval(onclick);
					}
				} );
			} );
	} );
	$('[mj_oc_container]',ctx).not('.mjh_oc').addClass('mjh_oc').each( function _mjh_oc() {
		this.ondrag = mj_return_false;
		this.ondragstart = mj_return_false;
		this.onselectstart = mj_return_false;
		var s=$(this), c=$(s.attr('mj_oc_container')), o=oc_states[s.attr('mj_oc_id')];
		if( typeof o === 'undefined' ? s.attr('mj_oc_default')=='open' : o ) {
			c.css('display',s.attr('mj_oc_display')||'block');
			s.addClass('opened');
		} else {
			c.css('display','none');
		}
	} );
}


export function toggle_oc_container( id, open ) {
	var e0;
	if( (e0=document.getElementById(id))===null ) return;
	//if( open ) $('.mjh_oc',e0).not('.opened').trigger('click');		// open container
	//else $('.mjh_oc',e0).filter('.opened').trigger('click');			// close container
	$('.mjh_oc',e0)[open?'not':'filter']('.opened').trigger('click');	// open or close container
}

